import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PlannerTaskInfo } from './types';
import { OverdueRescheduleOption } from './scheduleViewTypes';

type Section = 'root' | 'today' | 'later' | 'custom';

interface ScheduleRescheduleModalProps {
    onClose: () => void;
    onReschedule: (option: OverdueRescheduleOption, customTime?: string) => void;
    taskInfo: PlannerTaskInfo;
}

export const ScheduleRescheduleModal: React.FC<ScheduleRescheduleModalProps> = ({
    onClose, onReschedule, taskInfo,
}) => {
    const { t } = useTranslation();
    const date = new Date(taskInfo.task.dueDate!);
    const [section, setSection] = useState<Section>('root');
    const [customTime, setCustomTime] = useState(
        `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
    );
    const apply = (option: OverdueRescheduleOption, time?: string) => {
        onReschedule(option, time);
        onClose();
    };
    return (
        <div className="schedule-reschedule-modal-overlay" onClick={(event) => {
            event.stopPropagation();
            onClose();
        }}>
            <div className="schedule-reschedule-modal" role="dialog" aria-modal="true"
                aria-label={t('dailyPlanner.reschedule')} onClick={(event) => event.stopPropagation()}>
                <div className="schedule-reschedule-modal-header">
                    <span>{t('dailyPlanner.reschedule')}</span>
                    <button type="button" onClick={onClose} aria-label={t('dailyPlanner.cancel')}>×</button>
                </div>
                {section === 'root' && (
                    <div className="schedule-reschedule-options">
                        <button type="button" onClick={() => setSection('today')}>{t('dailyPlanner.today')}</button>
                        <button type="button" onClick={() => setSection('later')}>{t('dailyPlanner.later')}</button>
                    </div>
                )}
                {section === 'today' && (
                    <div className="schedule-reschedule-options">
                        <button type="button" onClick={() => apply('today-all-day')}>{t('dailyPlanner.allDay')}</button>
                        <button type="button" onClick={() => apply('today-morning')}>{t('dailyPlanner.morning')}</button>
                        <button type="button" onClick={() => apply('today-afternoon')}>{t('dailyPlanner.afternoon')}</button>
                        <button type="button" onClick={() => apply('today-evening')}>{t('dailyPlanner.evening')}</button>
                        <button type="button" onClick={() => apply('today-night')}>{t('dailyPlanner.night')}</button>
                        <button type="button" onClick={() => setSection('custom')}>{t('dailyPlanner.custom')}</button>
                    </div>
                )}
                {section === 'later' && (
                    <div className="schedule-reschedule-options">
                        <button type="button" onClick={() => apply('later-tomorrow')}>{t('dailyPlanner.tomorrow')}</button>
                        <button type="button" onClick={() => apply('later-two-days')}>{t('dailyPlanner.inTwoDays')}</button>
                        <button type="button" onClick={() => apply('later-next-week')}>{t('dailyPlanner.nextWeek')}</button>
                        <button type="button" onClick={() => apply('later-next-available')}>{t('dailyPlanner.nextAvailable')}</button>
                        <button type="button" onClick={() => apply('later-someday')}>{t('dailyPlanner.someday')}</button>
                    </div>
                )}
                {section === 'custom' && (
                    <div className="schedule-custom-time">
                        <input type="time" value={customTime} onChange={(event) => setCustomTime(event.target.value)} />
                        <button type="button" onClick={() => apply('today-custom', customTime)}>{t('dailyPlanner.apply')}</button>
                    </div>
                )}
            </div>
        </div>
    );
};
